import { shouldDisplayDesktopSection } from 'App/Navigation/shouldDisplayDesktopSection';
import { isSimpleView } from 'App/Navigation/utils';
import { hasUIProperty, UIProperty } from 'Environment/hasUIProperty';
import { IsAvailable } from 'Router/ReactRoute';

export function checkDesktopsAvailabilityForDaasVision(props: IsAvailable<{}>): boolean {
	const { workspaceConfiguration, resourceContext } = props;
	const shouldDisplayDesktop =
		hasUIProperty(workspaceConfiguration, UIProperty.Desktops) &&
		shouldDisplayDesktopSection(resourceContext.resources, workspaceConfiguration);

	return shouldDisplayDesktop && !isSimpleView(resourceContext.resources);
}
